import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { InformationBarActions } from '../../core/reducers/informationBar.actions';
import { TraceService } from './../core/services/trace.service';
import { Trace } from './../core/viewmodels/trace';
import { BzgToastService } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { TraceActions } from '../core/reducers/trace.actions';

@Component({
  selector: 'biz-trace-node-list',
  templateUrl: './trace-node-list.component.html',
  styleUrls: ['./trace-node-list.component.scss']
})
export class TraceNodeListComponent implements OnInit {

  public isSelectedAll = false;
  public showLoading = true;
  public loadingMessage = '';
  public nodes: ITraceNode[];
  public selectedNodeParent: ITraceNode;
  public selectedNodeLevel2: ITraceNode;
  public showMenuOption: any[] = [];
  private _trace: Trace;
  private _nodes: Array<ITraceNode>;
  private _traceActions: TraceActions;

  constructor(
    public _store: Store<any>,
    private _informationBarActions: InformationBarActions,
    public _dataService: TraceService,
    private _toastService: BzgToastService,
    private _translateService: TranslateService
  ) { }

  ngOnInit() {

    this._dataService.getTraceConfiguration()
      .subscribe(
        (res: ITrace) => {
          this._trace = new Trace(res);
          this.nodes = this._trace.Tracing;
          if (this.nodes && this.showMenuOption.length === 0) {
            this.nodes.forEach(node => {
              this.showMenuOption.push({ DataKeyString: node.DataKeyString, value: false });
              if (node.Nodes)
                this.setChildren(node.Nodes);
            });
          }
        },
        (error) => this.showLoading = false,
        () => this.showLoading = false
      );

  }

  lookForNode(nodes, node) {
    for (let index = 0; index < nodes.length; index++) {
      if (nodes[index].DataKeyString === node.DataKeyString) {
        nodes[index].nodes = node.Nodes;
        break;
      } else {
        if (node.nodes)
          this.lookForNode(nodes[index].Nodes, node);
      }
    }
  }

  setChildren(nodes) {
    nodes.forEach(node => {
      this.showMenuOption.push({ DataKeyString: node.DataKeyString, value: false });
      if (node.Nodes)
        this.setChildren(node.Nodes);
    });
  }

  public viewChildren(node: ITraceNode) {
    if (!node.Nodes || node.Nodes.length === 0) {
      return;
    }
    if (this.selectedNodeParent && node.DataKeyString === this.selectedNodeParent.DataKeyString) {
      this.selectedNodeParent = null;
      return;
    }
    this.selectedNodeParent = node;
  }

  public setLevel(state: string) {
    this.nodes = this.nodes.map((element: ITraceNode) => {
      if (element.Selected) {
        element.Level = state;
      }

      _.forEach(element.Nodes, (child) => {
        if (child.Selected) {
          child.Level = state;
        }
        _.forEach(child.Nodes, (child2) => {
          if (child2.Selected) {
            child2.Level = state;
          }
        });
      })
      return element;
    });
  }

  public onToggleSelectAll(status: string) {
    this.isSelectedAll = !this.isSelectedAll;
    this._selectNodes(status);
    this._store.dispatch(this._traceActions.SelectAll(this.isSelectedAll));
  }

  public save() {
    this.showLoading = true;
    this.loadingMessage = 'Saving..';
    const trace = new Trace({ Tracing: this.nodes } as ITrace);
    this._dataService.saveTraceConfiguration(trace)
      .subscribe(
        () => this._notifySuccessOperation(),
        (error) => this.showLoading = false,
        () => this.showLoading = false
      );
  }

  public getNodes(data) {
    this.lookForNode(this.nodes, data.nameParent);
  }

  private _selectNodes(state: string): void {
    this.getChildren(this.nodes, state);
  }

  getChildren(nodes: ITraceNode[], state: string) {
    if (nodes) {
      nodes.forEach((element: ITraceNode) => {
        element.Level = state;
        if (element.Nodes)
          this.getChildren(element.Nodes, state);
      });
    }
  }

  private _notifySuccessOperation() {
    this._translateService.get('TRACE_CONFIGURATION.SUCCESS_MSG').subscribe((message: string) => {
      this._toastService.open(
        message,
        {
          type: 'success',
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'right'
        });
    });
  };

}
